import { object, string, array } from 'yup';
import { LocationData } from '@web-shared/api/autocomplete/locations/types/LocationData';

export interface CreateBolFormValues {
  reference_number: string;
  token: string;
  location: LocationData | null;
  photos: string[];
}

export const initValues: CreateBolFormValues = {
  reference_number: '',
  token: '',
  location: null,
  photos: [],
};

const validations = [
  object().shape({
    reference_number: string().required(),
    location: object().nullable().required(),
  }),
  object().shape({
    photos: array().min(1),
  }),
  object().shape({
    token: string().required(),
  })
] as const;

export const getValidationSchema = (step: number) => {
  return validations[step];
};
